import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const MenuOpenIcon = ({
  color = 'white',
  width = 26,
  marginRight,
  marginLeft,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginRight={marginRight} marginLeft={marginLeft} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19">
      <g fill={getSemanticTextColor(color)} fillRule="evenodd">
        <path
          fillRule="evenodd"
          d="M25 16.5c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L25 18.5H1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L1 16.5h24zm0-8c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L25 10.5H1c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L1 8.5h24zm0-8c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L25 2.5H1c-.552 0-1-.448-1-1C0 .987.386.564.883.507L1 .5h24z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
